import React, { Component } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { AppState } from "src/store"
import AxiosConfig from "src/utilities/AxiosConfig"
import DynamicForm from "../DynamicForm/DynamicForm"
import stateMutator from "../Utils/StateMutator"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormTaskTypes from "../Types/DynamicFormTaskTypes"
import snackBar from "src/utilities/snackBar/SnackBar"
import FieldTypes from "../Types/FieldTypes"
import saveSetUp from "../Utils/SaveSetup"
import notificationStore from "src/utilities/Notifications/notificationStore"
import NotificationTypes from "src/utilities/Notifications/Types/NotificationTypes"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import completeFormTaskBoiler from "../Utils/CompleteFormTaskBoiler"
import userLocation from "../Utils/userLocation"
import { Spinner } from "react-bootstrap"

interface Props {
    notification: NotificationTypes
    manageParentState: Function
    user: EmployeeDataTypes | any
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    task: DynamicFormTaskTypes | null
    form: DynamicFormTypes | null
    schema: string
    completed: boolean
}

class FormTaskFiller extends Component<Props, State> {

    date = new Date();
    timeZoneOffset = -this.date.getTimezoneOffset()

    state = {
        task: null,
        form: null,
        schema: "",
        completed: false
    }

    componentDidMount() {
        this.findTask()
        // userLocation.getUserLocation()
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    findTask = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetEmployeeDynamicFormTasks/${this.props.user.userId}/*`, AxiosConfig.configValue("min"))
            .then((res) => {
                const tasks = res.data
                const task: DynamicFormTaskTypes = tasks.filter((obj: { DynamicFormWorkFlowId: number }) => {
                    return obj.DynamicFormWorkFlowId === this.props.notification.workFlowId
                })[0]
                if (task) {
                    this.manageState([
                        { key: "task", value: task },
                        { key: "form", value: task.DynamicForm },
                        { key: "schema", value: JSON.parse(JSON.stringify(task.DynamicForm.FieldsSchema)) },
                    ])
                } else {
                    this.findCompletedTask()

                }
            }).catch(err => {
                //console.log(err)
                snackBar({ text: "Error fetching form task", type: "error", timeout: 3000 })
            })
    }

    findCompletedTask = () => {
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetDynamicFormCompeletedTasksByEmploye/${this.props.user.userId}`, AxiosConfig.configValue("min"))
            .then((res) => {
                const tasks = res.data
                const task: DynamicFormTaskTypes = tasks.filter((obj: { DynamicFormWorkFlowId: number }) => {
                    return obj.DynamicFormWorkFlowId === this.props.notification.workFlowId
                })[0]
                if (task) {
                    this.getCompletedForm(task)
                }
            }).catch(err => {
                //console.log(err)
                snackBar({ text: "Error fetching form task", type: "error", timeout: 3000 })
            })
    }

    getCompletedForm = (task: DynamicFormTaskTypes) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetCompletedDynamicForm/${task.CustomFormDataId}`, AxiosConfig.configValue("min"))
            .then((res) => {
                let form: DynamicFormTypes = res.data.form
                form.FieldsSchema = form.FieldsValues
                this.manageState([
                    { key: "form", value: form },
                    { key: "completed", value: true }
                ])
                this.props.manageParentState([])//!! fix this, triggeres a re-render of the parent to populate the form pallette
            }).catch(err => {
                //console.log(err)
                snackBar({ text: "Error fetching form task", type: "error", timeout: 3000 })
            })
    }

    sumbit = (form: DynamicFormTypes, template: Array<Array<FieldTypes>> | [[]], helper: any) => {
        //@ts-ignore
        const fd = saveSetUp.setUpSave(form, template, this.props.userId, this.props.palette, false)
        let rb = {
            ...{ ...fd },
            ...{ FieldsSchema: this.state.schema },
            ...{ FieldsValues: fd.Fields },
            ...{ EmployeeId: this.props.user.userId },
            ...{ CustomFormDataId: 0 },
            ...{ Latitude: userLocation.coordinates.lat, Longitude: userLocation.coordinates.lng }
        }
        delete rb.Fields
        axios.post(process.env.REACT_APP_API_URL + "/api/Data/SaveDynamicFormData", rb, AxiosConfig.configValue("min"))
            .then((res) => {
                notificationStore.setOpenNotification(null)
                if (typeof (res.data) !== "number") {
                    notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
                    snackBar({ text: "Error saving form task (submit)", type: "error", timeout: 3000 })
                } else {
                    this.saveTask(helper, res.data)
                    snackBar({ text: "Form submitted", type: "success", timeout: 3000 })
                }
            }).catch((err: any) => {
                //console.log(err)
                snackBar({ text: "Error saving form task", type: "error", timeout: 3000 })
            })
    }

    saveTask = (helper: DynamicFormTaskTypes, CustomFormDataId: number,) => {
        let task = helper
        const completedTask = completeFormTaskBoiler.generateCompletedTask(task, this.props.user, CustomFormDataId)
        axios.post(process.env.REACT_APP_API_URL + "/api/company/SaveDynamicFormTask", { tasks: [completedTask] }, AxiosConfig.configValue("min"))
            .then((res) => {
                let errs = 0
                const resp = res.data
                for (let i = 0; i < resp.length; i++) {
                    if (!resp[i].error.success) {
                        errs++
                    }
                }
                if (errs > 0) {
                    snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
                    notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
                } else {
                    snackBar({ text: "Task completed", type: "primary", timeout: 3000 })
                    // notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [] } }])//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    notificationStore.getNotifications(this.props.user.userId)
                }

            }).catch((err: any) => {
                //console.log(err)
                snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
            })
    }

    render() {

        const state = this.state
        const props = this.props

        // console.log("FormTaskFiller state", state)
        // console.log("FormTaskFiller props", props)

        return (
            <div className="FormTaskFiller">
                {state.form && <DynamicForm
                    //@ts-ignore
                    form={state.form}
                    //@ts-ignore
                    helper={{ ...state.task, ...props.notification }}
                    addOrRemoveColumn={() => null}
                    submit={this.sumbit}
                    palette={props.palette}
                    readOnly={state.completed}
                />}
                {!state.form && <Spinner animation="border" />}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user,
    palette: state.dynamicFormPalette
})

export default connect(mapStateToProps)(FormTaskFiller)